export enum CartBillingAction {
  SetPaymentMethod = 'setPaymentMethod',
  SetCartData = 'setCartData',
  SetCurrentAddress = 'setCurrentAddress',
  SetIsInvoiceRequired = 'setIsInvoiceRequired',
  SetIsPopupVisible = 'setIsPopupVisible',
  SetGatewayId = 'setGatewayId',
}
